import script from "./sidebar-menu-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./sidebar-menu-item.vue?vue&type=script&setup=true&lang=ts"

import "./sidebar-menu-item.vue?vue&type=style&index=0&id=24f92b04&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24f92b04"]])

export default __exports__